import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "card-header border-0 pt-5 pb-3" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", { class: "card-title align-items-start flex-column" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "card-label fw-boldest text-gray-800 fs-2" }, " Transaction Summary"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-600 fw-bold mt-2 fs-6" }, "890 รายการวันนี้")
], -1)
const _hoisted_3 = { class: "d-flex align-items-center" }
const _hoisted_4 = {
  class: "btn btn-sm btn-icon btn-circle btn-icon btn-active-light",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-end",
  "data-kt-menu-flip": "top-end"
}
const _hoisted_5 = { class: "svg-icon svg-icon-1" }
const _hoisted_6 = { class: "card-body py-0" }
const _hoisted_7 = { class: "table-responsive" }
const _hoisted_8 = {
  class: "table align-middle table-row-bordered table-row-dashed gy-5 mt-13",
  id: "kt_table_widget_1"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("tr", { class: "text-start text-gray-400 fw-boldest fs-7 text-uppercase" }, [
  /*#__PURE__*/_createElementVNode("th", { class: "min-w-200px px-0" }),
  /*#__PURE__*/_createElementVNode("th", { class: "min-w-100px" }),
  /*#__PURE__*/_createElementVNode("th", { class: "min-w-100px" })
], -1)
const _hoisted_10 = { class: "py-3 px-0" }
const _hoisted_11 = { class: "d-flex align-items-center" }
const _hoisted_12 = { class: "symbol symbol-circle symbol-35px me-2" }
const _hoisted_13 = { class: "symbol-label" }
const _hoisted_14 = ["src"]
const _hoisted_15 = { class: "ps-3" }
const _hoisted_16 = {
  href: "#",
  class: "text-gray-800 fw-boldest fs-5 text-hover-primary mb-1"
}
const _hoisted_17 = { class: "text-gray-400 fw-bold d-block" }
const _hoisted_18 = { class: "px-0" }
const _hoisted_19 = { class: "text-gray-800 fw-boldest fs-5 d-block text-end" }
const _hoisted_20 = { class: "d-flex align-items-center" }
const _hoisted_21 = {
  style: {"padding":"5px","width":"70px"},
  class: "btn btn-sm btn-light-success fw-boldest"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-arrow-down" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([_ctx.widgetClasses, "card"]),
    style: {"height":"646px","max-height":"646px"}
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("a", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen023.svg" })
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("table", _hoisted_8, [
          _createElementVNode("tbody", null, [
            _hoisted_9,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, i) => {
              return (_openBlock(), _createElementBlock("tr", { key: i }, [
                _createElementVNode("td", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("span", _hoisted_13, [
                        _createElementVNode("img", {
                          alt: "",
                          class: "w-15px",
                          src: item.logo
                        }, null, 8, _hoisted_14)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("a", _hoisted_16, _toDisplayString(item.name), 1),
                      _createElementVNode("span", _hoisted_17, _toDisplayString(item.tools), 1)
                    ])
                  ])
                ]),
                _createElementVNode("td", _hoisted_18, [
                  _createElementVNode("span", _hoisted_19, _toDisplayString(item.company), 1)
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("button", _hoisted_21, [
                      _hoisted_22,
                      _createTextVNode(_toDisplayString(item.percent), 1)
                    ])
                  ])
                ])
              ]))
            }), 128))
          ])
        ])
      ])
    ])
  ], 2))
}